<template>
    <button
        type="button"
        class="flex w-full items-center gap-4 rounded-xl border border-black/10 px-4 py-3 text-left transition hover:border-primary/40 hover:bg-stone-50"
        :disabled="isOpening"
        @click="emits('open')"
    >
        <img v-if="project.preview_image !== ''" :src="project.preview_image" :alt="project.name" class="size-24 shrink-0 rounded-lg object-cover" />

        <div v-else class="flex size-24 shrink-0 items-center justify-center rounded-lg bg-stone-100">
            <ImageIcon class="size-8 text-stone-300" />
        </div>

        <div class="min-w-0 flex-1">
            <div class="font-semibold text-black">{{ project.name }}</div>
            <div v-if="project.sheet_count !== null" class="text-sm text-black/60">
                {{
                    $t('pages.product_detail_page.product_info.product_button.recent_projects_modal.sheet_count', {
                        count: project.sheet_count,
                    })
                }}
            </div>
            <div v-if="project.updated_at" class="text-sm text-black/50">
                {{
                    $t('pages.product_detail_page.product_info.product_button.recent_projects_modal.updated_at', {
                        date: formatDate(project.updated_at, { format: 'datetime' }),
                    })
                }}
            </div>
        </div>

        <div class="shrink-0 text-sm font-semibold text-primary">
            <span v-if="isOpening">
                {{ $t('pages.product_detail_page.product_info.product_button.recent_projects_modal.opening') }}
            </span>
            <span v-if="!isOpening">
                {{ $t('pages.product_detail_page.product_info.product_button.recent_projects_modal.open_project') }}
            </span>
        </div>
    </button>
</template>

<script setup lang="ts">
import type { RecentProject } from '@/types/PhotobookRecentProject';
import { formatDate } from '@/utils/formatOrderDate';
import { ImageIcon } from '@lucide/vue';

defineProps<{
    project: RecentProject;
    isOpening: boolean;
}>();

const emits = defineEmits<{
    open: [];
}>();
</script>
